import React from 'react';
import { Modal, Button, message, Spin } from 'antd';
import { withTranslation } from 'react-i18next';
import { closeImg, closeOnImg, closeOnLightImg } from '@/asserts/imgs/common/index';
import common from '@/asserts/js/common';
import APPstyles from '@/App.less';
import styles from '../note/index.less';

class AgreeNoticeIndex extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      chgCloseImg:closeImg,
      user_email:'',
      careData:[
        {

          num:'一、',
          title:'除簽署上述風險預告書外，買賣下列外國有價證券需符合一定資格條件:',
          data:[
            {num:'1.',title:'首次買賣具槓桿或放空效果之ETF，且以正向不超過二倍或反向不超過一倍者，或'},
            {num:'2.',title:'欲交易香港創業版股票、封閉型基金(CEF)者'}
          ],
        },
        {
          num:'二、',
          title:'委託人均需符合下列資格條件之一，始可買賣:',
          data:[
            {num:'1.',title:'已開立國內信用交易帳戶。'},
            {num:'2.',title:'最近一年內委託買賣國內或外國認購（售）權證成交達十筆（含）以上。'},
            {num:'3.',title:'最近一年內委託買賣國內或外國期貨交易契約成交達十筆(含)以上。'},
            {num:'4.',title:'委託買賣國內或外國證券交易市場掛牌之槓桿或放空效果ETF之成交紀錄。'},
          ],
        }
      ],
      listData:[
        {name:'帳號',value:''},
        {name:'簽署日期',value:''},
        {name:'簽署狀態',value:''},
        {name:'動作',value:''},
      ],
      clientAid:'',
      riskStatus:'',
      isQeryBtnShow:true,
      isQeryLoading:false
    }
  }
  onCloseClick(){
    this.props.cbBtnDataFun('close');
  };
  onMouseOver = () => {
    const {ChgThemeData} = this.props;
    let imgurl=ChgThemeData=='Light'?closeOnLightImg:closeOnImg;
    this.updateImage(imgurl);
  };
  onMouseOut = () => {
    this.updateImage(closeImg);
  };
  updateImage(imgurl) {
    const {isPC} = this.props;
    if(!isPC) return;
    this.setState({
      chgCloseImg: imgurl,
    });
  };
  riskNoticeFun(){
    const {listData}=this.state;

    fetch(common.getHttpZs+'getSignRiskNotice',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token'),
        source_type:2,
      })
    })
    .then(res1 => res1.json())
    .then(res1 => {
      if(res1['status']==0){
        // sign_status: [0]已签署，[1]未签署，[10]签署中
        const data = res1['data'];
        const sign_status = data['sign_status'];
        listData[1]['value']=sign_status==0?data['agree_date']:'';
        listData[2]['value']=sign_status==1?'未簽署':sign_status==10?'簽署中':'已簽署';

        this.setState({
          listData,
          riskStatus:sign_status,
          isQeryBtnShow: sign_status == 1
        });
      } else {
        message.warning({
          content: res1['message']
        });
      }
    })
    .catch(error => {
      console.error('API 请求出错:', error);
    })
    .finally(() => {
      this.setState({
        isQeryLoading: false
      });
    });
  }
  checkUserEmail(){
    fetch(common.getHttpZs+'getUserEmail',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token'),
      })
    })
    .then(res => res.json())
    .then(res => {
      if(res['status']==0){
        const data = res['data'];
        this.setState({
          user_email:data['user_email'],
        });
      }
    })
  }
  // 查询签署状态
  onQueryClick(){
    const {isQeryLoading,riskStatus}=this.state;
    if(isQeryLoading) return;

    if(riskStatus == 1){
      this.props.cbBtnDataFun('open');
    }else{
      this.setState({
        isQeryLoading:true
      });
      this.riskNoticeFun();
    }
  }
  componentDidMount() {
    const {aid}=this.props;
    const {listData}=this.state;
    
    const updaeAid = aid || sessionStorage.getItem('aidListId');
    listData[0]['value'] = updaeAid;

    this.setState({
      listData,
      clientAid:updaeAid
    });

    this.checkUserEmail();
  };
  
  render(){
    const {t,isMobile,ChgThemeData,visible}=this.props;
    const {chgCloseImg,careData,listData,user_email,clientAid,riskStatus,isQeryBtnShow,isQeryLoading}=this.state;
    return (
      <Modal 
        centered={true}
        closeIcon={null}
        footer={null}
        maskClosable={false}
        open={visible}
        transitionName=''
        maskTransitionName=''
        className={[
          styles.agreeCon,
          styles.agreeNoticeCon,
          APPstyles.flex_column,
          ChgThemeData=='Light'?styles.modalLight:'',
          isMobile?styles.agreeConMobile:''
        ].join(' ')}
      >
        <div className={[styles.noteTitle,APPstyles.flex_between,ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white,ChgThemeData==='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark].join(' ')}>
          <span>{t('複委託風險預告書')}</span>
          <img 
            src={chgCloseImg} 
            className={APPstyles.img24} 
            onClick={()=>this.onCloseClick()}
            onMouseOver={()=>this.onMouseOver()}
            onMouseOut={()=>this.onMouseOut()}
          />
        </div>
        <div className={[styles.agreeContent,APPstyles.flex1_auto].join(' ')}>
          <div className={[styles.messageCon,APPstyles.flex_row,ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark].join(' ')}>
            <span className={APPstyles.color_grey}>請選擇帳號:</span>
            <span className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white}>{clientAid}</span>
          </div>
          <div className={[styles.messageCon,APPstyles.flex_row,ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark].join(' ')}>
            <span className={APPstyles.color_grey}>電子信箱:</span>
            <span className={[ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white].join(' ')} style={{wordBreak:'break-all'}}>{user_email}</span>
          </div>
          <span className={styles.lineCon}>&nbsp;</span>
          <div className={APPstyles.flex_column} style={{padding:16}}>
            <div className={APPstyles.flex_column} style={{color:'#F5475B'}}>
              <span className={styles.titleCon}>請注意：</span>
              {careData.map((item, index) => {
                return (
                  <div key={index}>
                    <div className={[APPstyles.flex_row,styles.titleCon].join(' ')}>
                      <span>{item['num']}</span>
                      <span>{item['title']}</span>
                    </div>
                    {item['data'].map((item1, index1) => {
                      return (
                        <div key={index1} style={{padding:'0 16px'}}>
                          <div className={APPstyles.flex_row} style={{marginBottom:6}}>
                            <span>{item1['num']}&nbsp;</span>
                            <span>{item1['title']}</span>
                          </div>
                        </div>
                      )})
                    }
                  </div>
                )})
              }
            </div>
            <span className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white} style={{fontWeight:'700',margin:'4px 0 16px 0'}}>
              ＊表單編號：複委託(客)050—111.11 經紀業務作服部版
            </span>
            <div className={[isMobile?APPstyles.flex_column:APPstyles.flex_row,styles.accountListCon,ChgThemeData=='Light'?APPstyles.border_light:APPstyles.border_dark].join(' ')}>
              {listData.map((item, index) => {
                  return (
                    <div 
                      key={index} 
                      className={[
                        styles.accountList,
                        APPstyles.flex_1,
                        isMobile?APPstyles.flex_row:APPstyles.flex_column,
                        ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white,
                        index===listData.length-1?'':ChgThemeData=='Light'?isMobile?APPstyles.borderBottom_light:APPstyles.borderRight_light:isMobile?APPstyles.borderBottom_dark:APPstyles.borderRight_dark
                      ].join(' ')}
                    >
                      <span 
                        className={[
                          APPstyles.flex_center,
                          styles.agreeNoticeSpan,
                          styles.agreeNoticeTitle,
                          isMobile?ChgThemeData=='Light'?APPstyles.borderRight_light:APPstyles.borderRight_dark:''
                        ].join(' ')}
                      >
                        {item['name']}
                      </span>
                      <div className={[isMobile?APPstyles.flex_1:'',APPstyles.flex_center,styles.agreeNoticeSpan].join(' ')}>
                        {(isQeryBtnShow && index === 3) &&
                            <Button 
                              type='default'
                              className={[APPstyles.bg_blue,APPstyles.btn_blue].join(' ')}
                              onClick={this.onQueryClick.bind(this)} 
                            >
                            {t(riskStatus == 1 ? '進入簽署流程' : '簽署狀態查詢')}
                          </Button>
                        }      
                        {((!isQeryBtnShow && index === 3) || index !== 3) &&
                          <span>{item['value']}</span>
                        }
                        {(isQeryLoading && (index === 1 || index === 2)) && 
                          <div className={APPstyles.isLoading}>
                            <Spin spinning={isQeryLoading} size='small' />
                          </div>
                        }
                      </div>
                    </div>
                  )})
                }
            </div>
          </div>
        </div>
        <div 
          className={[
            styles.agreeBtnCon,
            APPstyles.flex_between,
            ChgThemeData=='Light'?APPstyles.bg_light:APPstyles.bg_content_dark,
            ChgThemeData=='Light'?APPstyles.borderTop_light:APPstyles.borderTop_dark
          ].join(' ')}
        >
          {riskStatus == 1 &&
            <Button className={[APPstyles.bg_grey,APPstyles.btn_gray].join(' ')} onClick={()=>this.onCloseClick()}>
              {t('Cancel')}
            </Button>
          }
          <Button className={[APPstyles.bg_blue,APPstyles.color_white].join(' ')} onClick={()=>this.onCloseClick()}>
            {t(riskStatus == 1 ? '同意簽署' : 'OK')}
          </Button>
        </div>
      </Modal>
  )}
}
export default withTranslation()(AgreeNoticeIndex);